var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"text"},[_c('p',[_vm._v(_vm._s(_vm.data.card_observation[0].description))]),_c('amaze-userfile',{key:_vm.data.card_observation[0].userfile.id,attrs:{"userfile":_vm.data.card_observation[0].userfile}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }